import { render, staticRenderFns } from "./SwitchBtn.vue?vue&type=template&id=16b4fa9a&scoped=true&"
import script from "./SwitchBtn.vue?vue&type=script&lang=js&"
export * from "./SwitchBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4fa9a",
  null
  
)

export default component.exports